export const primaryColor = `#070708`
export const secondaryColor = `#212529`
export const tertiaryColor = `#25ca7f`
export const backgrounColor = `#0e0f10`
export const lightGray = `#7a8086`
export const darkGray = `#333`

export const transparentTertiaryColor = `#25ca807e`